import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import * as React from 'react';
import { ILinkUrl } from '../actions/testForm';
import * as Actions from '../actions/testResult';
import { ITestResultState } from '../reducers/testResult';
import i18n from '../resources/i18n';
import TestResultQuestion from './TestResultQuestion';
/**
 * テスト結果全問一ページ形式コンポーネントProps
 */
export interface ITestResultSingleProps extends ITestResultState {
	classes: {
		resultRight: string;
		resultWrong: string;
		root: string;
		titleFailed: string;
		titlePassed: string;
		group: string;
		groupTitle: string;
		question: string;
		questionImage: string;
		questionImageContainer: string;
		questionTitle: string;
		hint: string;
	};
	careerID: string;
	lang: string;
	testID: string;
	questionGroupDisplay: boolean;
}

/**
 * テスト結果全問一ページ形式コンポーネント
 * @param props Props
 */
const TestResultSingle: React.FC<ITestResultSingleProps> = props => {
	const {
		careerID,
		lang,
		testID,
		classes,
		score,
		scoreMessage,
		groups,
		questionGroupDisplay,
	} = props;

	const title = `${score}${i18n.t('TestResultSingle_0001')}  ${i18n.t(
		scoreMessage,
		{ ns: 'force' }
	)}`;
	const titleClass = props.passFlg
		? classes.titlePassed
		: classes.titleFailed;

	return (
		<div className={classes.root}>
			<Typography variant="h6" className={titleClass}>
				{title}
			</Typography>
			{groups.map((group, i) => (
				<Group
					key={i}
					group={group}
					classes={classes}
					questionGroupDisplay={questionGroupDisplay}
					careerID={careerID}
					lang={lang}
					testID={testID}
				/>
			))}
		</div>
	);
};
export default TestResultSingle;

interface IGroupProps {
	group: Actions.IGroup;
	classes: {
		group: string;
		groupTitle: string;
		question: string;
		questionImage: string;
		questionImageContainer: string;
		questionTitle: string;
		resultRight: string;
		resultWrong: string;
		hint: string;
	};
	careerID: string;
	lang: string;
	testID: string;
	questionGroupDisplay: boolean;
}

// グループ部分のコンポーネント
const Group: React.FC<IGroupProps> = props => {
	const { careerID, lang, testID } = props;
	return (
		<Paper className={props.classes.group}>
			<Grid container={true} spacing={3} alignItems="flex-end">
				<Grid item={true} xs={true}>
					{props.questionGroupDisplay && (
						<Typography
							variant="h6"
							className={props.classes.groupTitle}
							gutterBottom={true}
						>
							{props.group.groupTitle}
						</Typography>
					)}
				</Grid>
				<Grid item={true}>
					<Typography gutterBottom={true}>
						{i18n.t('TestResultSingle_0002', {
							correctCount: props.group.correctCount,
							quizCount: props.group.quizCount,
						})}
					</Typography>
				</Grid>
			</Grid>
			{props.group.questions.map((question, i) => {
				const linkUrlParam: ILinkUrl = {
					careerID,
					lang,
					preview: true,
					testID,
				};
				return (
					<TestResultQuestion
						key={i}
						question={question}
						classes={props.classes}
						linkUrlParam={linkUrlParam}
					/>
				);
			})}
		</Paper>
	);
};



// WEBPACK FOOTER //
// ./src/components/TestResultSingle.tsx